import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Toast, ConfirmModal } from '@components';
import ROUTES, { RenderRoutes } from './routes';
import runDatadog from './datadogConfig';

import './App.css';

const App = () => {
  const history = useHistory();
  const isProduction = process.env.NODE_ENV === 'production';

  useEffect(() => {
    if (isProduction) {
      runDatadog();
    }
  }, [isProduction]);

  useEffect(() => {
    return history.listen((location) => {
      window.top.postMessage({ reactLocation: location.pathname }, '*');
    });
  }, [history]);

  return (
    <div className='App'>
      <RenderRoutes routes={ROUTES} />

      <Toast />

      <ConfirmModal />
    </div>
  );
};

export default App;
